export const LOCALE = 'en-GB';
